module.exports = __webpack_public_path__ + "fonts/icons.ttf"


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-css/themes/default/assets/fonts/icons.ttf
 ** module id = 383
 ** module chunks = 0
 **/